import { Fragments } from "requests";

export const getDefaultValues = (
  generalAssessment: Fragments.StoredGeneralAssessment
) => ({
  rightRegionalBlocks: generalAssessment?.rightRegionalBlocks || [],
  rightInfraorbital: generalAssessment?.rightInfraorbital || null,
  rightMaxillary: generalAssessment?.rightMaxillary || null,
  rightRostralMandibular: generalAssessment?.rightRostralMandibular || null,
  rightInferiorAlveolar: generalAssessment?.rightInferiorAlveolar || null,
  leftRegionalBlocks: generalAssessment?.leftRegionalBlocks || [],
  leftInfraorbital: generalAssessment?.leftInfraorbital || null,
  leftMaxillary: generalAssessment?.leftMaxillary || null,
  leftRostralMandibular: generalAssessment?.leftRostralMandibular || null,
  leftInferiorAlveolar: generalAssessment?.leftInferiorAlveolar || null,
  oralSurgeries: generalAssessment?.oralSurgeries || [],
  orthodontics: generalAssessment?.orthodontics || [],
  periodontics: generalAssessment?.periodontics || [],
  planingAndSubgingivalCurettage:
    generalAssessment?.planingAndSubgingivalCurettage || null,
  boneAugmentation: generalAssessment?.boneAugmentation || false,
  boneAugmentationDetails: generalAssessment?.boneAugmentationDetails || null,
  treatmentAdditionalFindingsCommentsAndNotes:
    generalAssessment?.treatmentAdditionalFindingsCommentsAndNotes || ""
});
